import { ActionBar, Group, IconButton, Portal, Text } from 'chakra-ui-next'
import * as React from 'react'
import { LuX } from 'react-icons/lu'
import { CloseButton } from './close-button'

interface ActionBarContentProps extends ActionBar.ContentProps {
  portalled?: boolean
  portalRef?: React.RefObject<HTMLElement>
}

export const ActionBarContent = React.forwardRef<HTMLDivElement, ActionBarContentProps>(
  function ActionBarContent(props, ref) {
    const { children, portalled = true, portalRef, ...rest } = props

    return (
      <Portal disabled={!portalled} container={portalRef}>
        <ActionBar.Positioner>
          <ActionBar.Content ref={ref} {...rest} asChild={false}>
            {children}
          </ActionBar.Content>
        </ActionBar.Positioner>
      </Portal>
    )
  },
)

export const ActionBarCloseTrigger = React.forwardRef<
  HTMLButtonElement,
  ActionBar.CloseTriggerProps
>(function ActionBarCloseTrigger(props, ref) {
  return (
    <ActionBar.CloseTrigger {...props} asChild ref={ref}>
      <CloseButton size="sm" />
    </ActionBar.CloseTrigger>
  )
})

export const ActionBarRoot = ActionBar.Root
export const ActionBarSelectionTrigger = ActionBar.SelectionTrigger
export const ActionBarSeparator = ActionBar.Separator

interface ActionBarSelectionCounterProps {
  selectedCount: number
  onDeselect: () => void
}

export const ActionBarSelectionCounter = React.forwardRef<
  HTMLButtonElement,
  ActionBarSelectionCounterProps
>(function ActionBarSelectionCounter({ selectedCount, onDeselect }, ref) {
  return (
    <ActionBarSelectionTrigger ref={ref} pr="1" gap="1" asChild>
      <Group>
        <Text color="fg.muted">{selectedCount} selected</Text>
        <IconButton size="sm" variant="plain" onClick={onDeselect}>
          <LuX />
        </IconButton>
      </Group>
    </ActionBarSelectionTrigger>
  )
})
